import React from 'react';
import { LayerWrapper } from './LayerWrapper';
import type { TopBarLayer as TopBarLayerConfig } from '../../types';

interface TopBarLayerProps {
  layer: TopBarLayerConfig;
}

export function TopBarLayer({ layer }: TopBarLayerProps) {
  const { position, animation, opacity, backgroundColor } = layer;

  return (
    <LayerWrapper position={position} animation={animation} opacity={opacity}>
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor,
        }}
      />
    </LayerWrapper>
  );
}
